// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

function CompTabs$Tab(Props) {
  var name = Props.name;
  var selected = Props.selected;
  var linkTo = Props.linkTo;
  var c = selected === name ? "is-active" : "";
  return React.createElement("li", {
              className: c
            }, React.createElement("a", {
                  onClick: (function (param) {
                      return RescriptReactRouter.push(linkTo);
                    })
                }, name));
}

var Tab = {
  make: CompTabs$Tab
};

function CompTabs(Props) {
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var match = url.path;
  var selected;
  if (match) {
    switch (match.hd) {
      case "comp" :
          selected = "Tasks";
          break;
      case "pilots" :
          selected = "Pilots";
          break;
      case "settings" :
          selected = "Settings";
          break;
      default:
        selected = "";
    }
  } else {
    selected = "";
  }
  return React.createElement("div", {
              className: "tabs"
            }, React.createElement("ul", undefined, React.createElement(CompTabs$Tab, {
                      name: "Settings",
                      selected: selected,
                      linkTo: "/settings"
                    }), React.createElement(CompTabs$Tab, {
                      name: "Tasks",
                      selected: selected,
                      linkTo: "/comp"
                    }), React.createElement(CompTabs$Tab, {
                      name: "Pilots",
                      selected: selected,
                      linkTo: "/pilots"
                    })));
}

var make = CompTabs;

export {
  Tab ,
  make ,
  
}
/* react Not a pure module */
